import './contact-us.css';
import AssetImg from '../lib/asset-img';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';

export function FromParameters({ pageID }) {
    const [details, setDetails] = useState(null);

    useEffect(() => {
        fetch(`/v1/api/pages/${pageID}/parameters/details/0/$blob`)
            .then(response => response.ok ? response.text() : Promise.reject())
            .then(data => setDetails(data))
            .catch(error => console.error('Error fetching contact details:', error));
    }, [pageID]);

    return <ContactUs img={`/v1/api/pages/${pageID}/parameters/img/0`} details={details} />;
}

function sendEmail() {
    const email = document.getElementById('email').value;
    const fullname = document.getElementById('fullname').value;
    const company = document.getElementById('company').value;
    const subject = document.getElementById('subject').value;
    const message = document.getElementById('message').value;

    if (!email || !fullname || !subject || !message) {
        toast.error('Please fill in all required fields.');
        return;
    }

    fetch('/v1/api/email', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            sender: email,
            fullname: fullname,
            company: company,
            subject: subject,
            body: message,
        })
    })
        .then(response => response.ok ? Promise.resolve() : Promise.reject())
        .then(() => {
            toast.success('Email sent successfully!');
        })
        .catch(error => {
                console.error('Error sending email:', error);
                toast.error('Failed to send email.');
        })
}


export default function ContactUs({ img, details }) {
    return <div className="contact-us">
        <div className='email-form'>
            <div className='email-panel'>
                <div className='email-top'>
                    <input id='email' type='email' placeholder='*Your Email' />
                    <input id='fullname' type='text' placeholder='*Your Full Name' />
                    <button id='send-email' onClick={sendEmail} title='Send Email'><FontAwesomeIcon icon={faEnvelope} /></button>
                </div>
                <input id='company' type='text' placeholder='Your Company Name' />
                <input id='subject' type='text' placeholder='*Subject' />
                <textarea id='message' placeholder='*Your Message'></textarea>
            </div>
        </div>
        <div className='contact-details'>
            {img && <AssetImg url={img} />}
            {details && <div className='backing' dangerouslySetInnerHTML={{ __html: details }} />}
        </div>
        <ToastContainer />
    </div>
}